import { createTheme } from './createTheme';

export * from './createTheme';
export * from './ThemeProvider';

export const defaultDarkTheme = createTheme({ type: 'dark' });
export const defaultLightTheme = createTheme({ type: 'light' });
